export default {
  0: `
    [6,8]
      +++
     +   +
     +  ++
     + + +
     ++  +
     +   +
      +++
  `,
  1: `
    [6,8]
       +
      ++
       +
       +
       +
       +
      +++
  `,
  2: `
    [6,8]
      +++
     +   +
        +
       +
      +
     +
     +++++
  `,
  3: `
    [6,8]
      +++
     +   +
         +
       ++
         +
     +   +
      +++
  `,
  4: `
    [6,8]
        +
       ++
      + +
     +  +
     +++++
        +
        +
  `,
  5: `
    [6,8]
     +++++
     +
     +
      +++
         +
     +   +
      +++
  `,
  6: `
    [6,8]
      +++
     +   +
     +
     ++++
     +   +
     +   +
      +++
  `,
  7: `
    [6,8]
     +++++
         +
        +
       +
      +
      +
      +
  `,
  8: `
    [6,8]
      +++
     +   +
     +   +
      +++
     +   +
     +   +
      +++
  `,
  9: `
    [6,8]
      +++
     +   +
     +   +
      ++++
         +
     +   +
      +++
  `,
}



// WEBPACK FOOTER //
// ./src/dot-fonts/numbers.js